export default __webpack_public_path__ + "static/media/limit_65.837537b8.svg";